import { createContext } from "react";
import { AlertProps } from "@justworkshr/milo-core";

export type Alert = {
  message: string;
  color?: AlertProps["color"];
};

type PageAlertContextType = {
  alert: Alert;
  setAlert: ({ message, color }: Alert) => void;
  removeAlert: () => void;
};

const PageAlertContext = createContext<PageAlertContextType>({
  alert: { message: "" },
  setAlert: () => undefined,
  removeAlert: () => undefined,
});

export default PageAlertContext;
